import { ICaptcha, IErrorReport, IFindMemberRequest, IFindMemberResponse, IMember, IResponse } from "@common/models";
import Api, { IOptions } from "@service/Api";
import { Action } from "./Proxy";

export function authenticate<T = any, U = any>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.GET:
            return Api.get<T, U>("Auth", { ...options, raiseError: options?.raiseError ?? false });
        case Action.POST:
            return Api.post<T, U>("Auth", { ...options, raiseError: options?.raiseError ?? false });
    }
    return Promise.reject();
}

export function captchaApi<T = any, U = ICaptcha>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.GET:
            return Api.get<T, U>("Captcha", { ...options, raiseError: options?.raiseError ?? false });
    }
    return Promise.reject();
}

export function reloadCaptcha<T = any, U = ICaptcha>(action: Action, captchaId: string, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.GET:
            return Api.get<T, U>(`Captcha/Reload/${captchaId}`, { ...options, raiseError: options?.raiseError ?? false });
    }
    return Promise.reject();
}

export function member<T = IMember, U = IMember>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.GET:
            return Api.get<T, U>("Member", { ...options, raiseError: options?.raiseError ?? true });
        case Action.POST:
            return Api.post<T, U>("Member", { ...options, raiseError: options?.raiseError ?? true });
    }
    return Promise.reject();
}

export function findMemberId<T = IFindMemberRequest, U = IFindMemberResponse>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Member/Find", { ...options, raiseError: options?.raiseError ?? true, captchaRequierd: options?.captchaRequierd ?? true });
    }
    return Promise.reject();
}

export function sendError<T = IErrorReport, U = string>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Client/Error", { ...options, raiseError: options?.raiseError ?? false });
    }
    return Promise.reject();
}